import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

const { Get, Put, Post } = axiosInstanceApiGateway

export type GetIsochroneVersionListResponseType = {
  data: {
    list: {
      location: { id: number; name: string }[]
      sla: {
        id: number
        name: string
      }[]
      version: string
      active: boolean
      updated_by: string
      updated_at: string
      id: string
    }[]
    active_version: string
  }
  pagination: {
    next_page_exist: boolean
    previous_page_exist: boolean
    page_size: number
    page_cursor: string
    cursor_direction: string
    page_item: number
    previous_cursor: string
    next_cursor: string
  }
  error: {
    status: boolean
    message: string
    code: number
  }
}

export type GetIsochroneVersionListRequestType = {
  params: {
    limit: number
    cursor?: string
    direction?: 'next' | 'prev'
  }
}

export const getIsochroneVersionList = ({ params }: GetIsochroneVersionListRequestType) =>
  Get<GetIsochroneVersionListResponseType, true>({
    url: `/location/internal/v1/location-geometry`,
    params,
  })

export type PutActivateIsochroneVersionRequestType = {
  id: string
}

export type PutActivateIsochroneVersionResponseType = {
  data: { message: string }
  error: { status: boolean; message: string; code: number }
}

export const putActivateIsochroneVersion = ({ id }: PutActivateIsochroneVersionRequestType) =>
  Put<PutActivateIsochroneVersionResponseType, true>({
    url: `/location/internal/v1/location-geometry/activate`,
    data: { version: id },
  })

export type PutDuplicateIsochroneVersionRequestType = {
  version: string
}

export type PutDuplicateIsochroneVersionResponseType = {
  data: { message: string }
  error: { status: boolean; code: number; message: string }
}

export const putDuplicateIsochroneVersion = ({
  version,
}: PutDuplicateIsochroneVersionRequestType) =>
  Put<PutDuplicateIsochroneVersionResponseType, true>({
    url: `/location/internal/v1/location-geometry/duplicate/${version}`,
  })

export type DeleteBulkIsochroneVersionRequestType = {
  id: string[]
}

export type DeleteBulkIsochroneVersionResponseType = {
  data: { message: string }
  error: { status: boolean; code: number; message: string }
}

export const deleteBulkIsochroneVersion = ({ id }: DeleteBulkIsochroneVersionRequestType) =>
  Post<DeleteBulkIsochroneVersionResponseType, true>({
    url: `/location/internal/v1/location-geometry/bulk-delete`,
    data: { ids: id },
  })
